import { render } from "./App.vue?vue&type=template&id=6d2de6c7&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6d2de6c7&lang=less&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2de6c7"]])

export default __exports__